import styled, { css } from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';
import Link from '@atoms/Link/Link';
import Spinner from '@components/molecules/Spinner/Spinner';
import Button from '@atoms/Button/Button';
import Config from '@config';

export const StyledCartPreview = styled.div<{ $isOpen: boolean }>`
  background-color: ${variables.colors.white};
  display: flex;
  flex-direction: column;
  border-left: ${rem(1)} solid ${variables.colors.mediumGray};
  -ms-overflow-style: ${(props) => (props.$isOpen ? 'auto' : 'none')};

  // Hide overflowing shadows
  overflow-x: hidden;

  // Below desktop settings
  z-index: ${variables.zIndex.cartPreview};
  position: fixed;
  top: 0;
  right: 0;

  ${Config.MEDIA.FROM_DESKTOP} {
    position: sticky;
    z-index: ${variables.zIndex.cart};
    top: ${rem(variables.size.toolbarHeight)};
  }

  transition-property: visibility, max-width;

  ${(props) =>
    props.$isOpen
      ? css`
          visibility: visible;
          max-width: ${rem(variables.size.cartPreviewWidth)};
          transition-delay: 0ms, 0ms;
          transition-duration: 0ms, ${variables.animation.layout};
        `
      : css`
          visibility: hidden;
          max-width: 0;
          transition-delay: ${variables.animation.layout}, 0ms;
          transition-duration: 0ms, ${variables.animation.layout};
        `};
`;

export const StyledHeader = styled.header`
  display: flex;
  justify-content: space-between;
  padding: ${rem(18)} ${rem(16)};

  border-bottom: ${rem(1)} solid ${variables.colors.mediumGray};
`;

export const StyledBody = styled.section`
  min-width: ${rem(variables.size.cartPreviewWidth)};
  height: 100%;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledLoadingContainer = styled.div`
  height: 100%;
  display: flex;
  text-align: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 ${rem(28)};
`;

export const StyledSpinner = styled(Spinner)`
  margin: ${rem(12)} 0;
  align-self: center;
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: ${rem(16)};
  padding: ${rem(16)};
`;

export const StyledEmptyCart = styled.div`
  display: flex;
  height: 100%;
  padding: ${rem(16)};
`;

export const StyledPriceGrid = styled.section`
  border-top: ${rem(1)} solid ${variables.colors.mediumGray};
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${rem(8)};
  padding: ${rem(16)} ${rem(16)} 0 ${rem(16)};
`;

export const StyledLink = styled(Link)`
  width: 100%;
  padding: ${rem(8)} ${rem(16)} ${rem(16)} ${rem(16)};
`;

export const StyledButton = styled(Button)`
  width: 100%;
`;
